import React from "react";
import { StarIcon as StarSolid } from "@heroicons/react/24/solid";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export default function CustomerReviews({
  customer_name,
  rating,
  date,
  review,
}: {
  customer_name: string;
  rating: number;
  date: string;
  review: string;
}) {
  return (
    <Card className='border-border-title/20 rounded-lg bg-[#F9FAFB] p-4 dark:bg-transparent'>
      <CardContent className='px-0'>
        <div className='space-y-3'>
          {/* Header: Name, Verified Badge, Date */}
          <div className='flex items-start justify-between gap-2'>
            <div className='flex flex-wrap items-center gap-2'>
              <span className='text-text-title text-base font-medium'>{customer_name}</span>

              <Badge
                variant='secondary'
                className='border-none bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
              >
                <CheckCircleIcon className='size-3' />
                <span className='text-xs font-medium'>Verified Purchase</span>
              </Badge>
            </div>
            <span className='shrink-0 text-sm text-[#6A7282]'>{date}</span>
          </div>

          {/* Star Rating */}
          <div className='flex items-center gap-0.5'>
            {Array.from({ length: 5 }).map((_, index) => {
              const isFilled = index < rating;
              return <StarSolid key={index} className={cn("size-4", isFilled ? "text-[#FFB900]" : "text-gray-300")} />;
            })}
          </div>

          {/* Review Text */}
          <p className='text-text-title text-sm leading-relaxed'>{review}</p>
        </div>
      </CardContent>
    </Card>
  );
}
